import styled from '@emotion/styled';
import { Form } from 'modules/common/ui';

export const FormRoot = styled(Form)``;
